import { useMemo } from 'react';
import { ReactComponent as BlockedIcon } from '@elementary/common-ui/assets/20x20/blocked.svg';
import { ReactComponent as EditIcon } from '@elementary/common-ui/assets/20x20/edit.svg';
import { ReactComponent as DeleteIcon } from '@elementary/common-ui/assets/20x20/trash.svg';
import { Menu, IconButton } from '@elementary/common-ui/components';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

type Props = {
  onChange: (val: string) => void;
  isActive: boolean;
  isDefault?: boolean;
};

const RuleMenu = ({ onChange, isActive, isDefault }: Props) => {
  const menuOptions = useMemo(
    () => [
      {
        value: isActive ? 'deactivate' : 'activate',
        label: isActive ? 'Deactivate' : 'Activate',
        icon: <BlockedIcon />,
      },
      {
        value: 'edit',
        label: 'Edit',
        icon: <EditIcon />,
      },
      {
        value: 'delete',
        label: 'Delete',
        icon: <DeleteIcon />,
        disabled: isDefault,
      },
    ],
    [isActive, isDefault],
  );

  return (
    <Menu
      menuButton={
        <IconButton sx={{ color: 'common.black', p: '2px !important' }}>
          <MoreHorizIcon />
        </IconButton>
      }
      options={menuOptions}
      onChange={onChange}
      boldOptions
      closeOnChange
    />
  );
};

export default RuleMenu;
